import * as React from 'react'
import { translateCountryName } from "@ui-seeker/utils"

import { LabelCountry } from "@components"


export default function countryColumn() {
	return [{
		name: 'country', label: 'Country',
		options: {
			display: 'excluded',
			customBodyRowRender: v => translateCountryName(v)
		}
	}, {
		name: 'country', label: 'Market',
		options: {
			filter: false,
			headerAlign: 'left',
			customBodyRowRenderLite: value => <LabelCountry country={value} label={translateCountryName(value)} />
		}
	}]
}